import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const queryDefaultOptions = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      staleTime: 0,
      retry: 0,
    },
  },
};

const queryClient = new QueryClient(queryDefaultOptions);
queryClient.getQueryCache().subscribe(event => {
  if (event?.type === 'observerResultsUpdated') {
    event.query?.invalidate();
  }
});
export const NetworkContext = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
